import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import { makePartnersAccountData } from '../../utils/balance-accounts';
import PartnerAccountsTable from '../../components/bills-accounts-statics/PartnerAccountsTable';

const PartnerAccountsContainer = ({
  selectedYear,
  selectedPrjTyp,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const onLoadData = () => {
    setLoading(true);
    const loadedData = makePartnersAccountData();
    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    onLoadData();
  }, [selectedYear, selectedPrjTyp]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <PartnerAccountsTable
          data={data}
          loading={loading}
          tableRef={tableRef}
        />
      )}
    </Box>
  );
};

export default PartnerAccountsContainer;
